/**
 * Types of profile
 * @enum {number}
 * @readonly
 */
const TProfile = {
    /**
     * Type admin
     * @type {number}
     * @constant
     */
    ADMIN: 1,
    /**
     * Type user
     * @type {number}
     * @constant
     */
    USER: 2,
}

export default TProfile
